import { render, staticRenderFns } from "./ChangePartner.vue?vue&type=template&id=76ff7986"
import script from "./ChangePartner.vue?vue&type=script&lang=js"
export * from "./ChangePartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports